var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-lg app-creation-object-section-card",attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"primary--text pt-5 pb-0"},[_vm._t("title")],2),_c('v-card-text',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }